module.exports = __webpack_public_path__ + "static/win-logo-c6038e46fb3379c42d8eb248ffd20848.png";